<!-- eslint-disable vue/valid-v-slot -->
<template>
  <v-container fluid class="caso-component">
    <v-flex xs12 class="text-center justify-center mb-4 mt-6">
      <h4 class="font-weight-bold">LISTA DE CASOS</h4>
    </v-flex>
    <v-card>
      <v-card-text>
        <filtros
          ref="criterios"
          :campos.sync="camposfiltros"
          @actualizarFiltro="getInfo"
          @nuevo="addUpdate"
        ></filtros>
      </v-card-text>
    </v-card>
    <v-data-table
      :headers="headers"
      :items="desserts"
      :options.sync="options"
      :loading="loading"
      class="elevation-1"
      :dense="true"
      no-data-text="Datos no disponibles"
      no-results-text="Cargando..."
      fixed-header
      :height="500"
      :footer-props="{
        'show-current-page': false,
        'show-first-last-page': false,
        'items-per-page-options': [],
        'items-per-page-text': '',
      }"
      :disable-sort="true"
    >
      <template v-slot:top>
        <v-toolbar flat></v-toolbar>
      </template>
      <template v-slot:footer.page-text>
        <v-row justify="end" align="center" class="ma-0 pa-0">
          <v-col class="col-content-footer">
            <v-btn
              type="button"
              :loading="loading"
              class="v-btn v-btn--icon v-btn--round v-btn--text theme--light v-size--default"
              :disabled="paginas.length === 0"
              @click="getDataAnterior"
              aria-label="Previous page"
            >
              <span class="v-btn__content">
                <i
                  aria-hidden="true"
                  class="v-icon notranslate mdi mdi-chevron-left theme--light"
                ></i>
              </span>
            </v-btn>
            <v-btn
              type="button"
              :loading="loading"
              :disabled="!ultimoDocumento"
              @click="getDataSiguiente"
              class="v-btn v-btn--icon v-btn--round v-btn--text theme--light v-size--default"
              aria-label="Next page"
            >
              <span class="v-btn__content">
                <i
                  aria-hidden="true"
                  class="v-icon notranslate mdi mdi-chevron-right theme--light"
                ></i>
              </span>
            </v-btn>
          </v-col>
        </v-row>
      </template>
      <template v-slot:[`item.id`]="{ item }">
        <v-btn
          v-if="
            cargo == 'Administrador' ||
            cargo == 'Coordinador Abogado' ||
            cargo == 'Coordinador Contact Center' ||
            cargo == 'Coordinador Investigador' ||
            cargo == 'Coordinador Perito' ||
            cargo == 'Coordinador Abogado CAIT'
          "
          small
          text
          icon
          outlined
          @click="asignar(item)"
          color="primary"
          title="Asignar agente"
        >
          <v-icon small>mdi-account-plus</v-icon>
        </v-btn>
        <v-btn
          v-if="
            cargo == 'Administrador' ||
            cargo == 'Coordinador Contact Center' ||
            cargo == 'Call Center' ||
            cargo == 'Coordinador Investigador' ||
            cargo == 'Investigador'
          "
          small
          icon
          text
          outlined
          @click="solicitar(item)"
          color="primary"
          title="Solicitar agente"
        >
          <v-icon small>mdi-library</v-icon>
        </v-btn>
        <v-switch
          v-model="tomarCaso"
          v-if="
            cargo == 'Investigador' ||
            cargo == 'Abogado' ||
            cargo == 'Dibujante'
          "
          color="primary"
          :value="item.id"
        ></v-switch>
      </template>
      <template v-slot:[`item.caso`]="{ item }">
        {{ item.caso }}
        <v-icon
          v-if="
            (cargo == 'Administrador' ||
              cargo == 'Coordinador Contact Center') &&
            item.solicitud_atencion &&
            !item.aprobar_atencion
          "
          color="orange"
          dense
          @click="autorizar(item)"
          title="Autorizar Permiso de gestión"
        >
          mdi-circle
        </v-icon>
      </template>
      <!--<template v-slot:[`item.area`]="{ item }">
        {{ item.area ? item.area : "Sin Definir" }}
      </template>-->
      <template v-slot:[`item.fecha_creacion`]="{ item }">
        {{ item.fecha_creacion }}
      </template>
      <template v-slot:[`item.hora_creacion`]="{ item }">
        {{ item.hora_creacion }}
      </template>
      <template v-slot:[`item.hora_asignacion`]="{ item }">
        {{ item.hora_asignacion }}
      </template>
      <template v-slot:[`item.poliza`]="{ item }">
        {{ polizaCaso(item) }}
      </template>
      <template v-slot:[`item.telefono_usuario_1`]="{ item }">
        {{ item.telefono_usuario_1 || "-" }}
      </template>
      <template v-slot:[`item.vehiculo_inmovilizado`]="{ item }">
        <v-tooltip v-if="item.vehiculo_inmovilizado === true" bottom>
          <template v-slot:activator="{ on, attrs }">
            <span
              v-bind="attrs"
              v-on="on"
              class="success--text font-weight-medium"
            >
              true
            </span>
          </template>
          <span>fue notificado a LiberaYa</span>
        </v-tooltip>
        <span v-else class="grey--text">false</span>
      </template>
      <template v-slot:[`item.origen_desde`]="{ item }">
        <span
          v-if="item.origen_desde !== 'Salesforce'"
          :class="
            item.origen_desde == 'Digipats' ? 'success--text' : 'warning--text'
          "
          class="font-weight-medium"
        >
          {{ item.origen_desde }}
        </span>
        <v-btn
          v-else
          small
          text
          color="primary"
          class="pa-0 font-weight-medium"
          @click="verMovilidadMundial(item)"
          title="Ver detalle Salesforce"
        >
          {{ item.origen_desde }}
        </v-btn>
      </template>
      <template v-slot:[`item.tiempos`]="{ item }">
        <v-btn
          small
          icon
          text
          outlined
          color="primary"
          title="Ver timeline del caso"
          @click="verTimeline(item)"
        >
          <v-icon small>mdi-eye</v-icon>
        </v-btn>
      </template>
      <template v-slot:[`item.perito`]="{ item }">
        {{ item.perito }}
        <v-badge
          v-if="!item.perito && item.solicitud_perito"
          dot
          inline
          color="orange"
        >
          Solicitando
        </v-badge>
      </template>
      <template v-slot:[`item.dibujante`]="{ item }">
        {{ item.dibujante }}
        <v-badge
          v-if="!item.dibujante && item.solicitud_dibujante"
          dot
          inline
          color="orange"
        >
          Solicitando
        </v-badge>
      </template>
      <template v-slot:[`item.archivar`]="{ item }">
        <v-chip
          v-if="item.estado !== 'Recibido'"
          small
          class="ma-2"
          :title="item.archivado ? 'Restablecer Caso' : 'Archivar Caso'"
          :color="!item.archivado ? 'red' : 'green'"
          outlined
          @click="archivar(item)"
        >
          <v-icon small> mdi-power </v-icon>
        </v-chip>
      </template>
      <template v-slot:[`item.infoCaso`]="{ item }">
        <v-btn
          @click="infoCaso(item)"
          color="primary"
          title="Información del caso"
          small
          icon
          text
          outlined
        >
          <v-icon small>mdi-magnify</v-icon>
        </v-btn>
      </template>
      <template v-slot:[`item.action`]="{ item }">
        <div :class="['contentGestiones']">
          <!-- Asignar / Solicitar (columna que se había eliminado) -->
          <v-btn
            v-if="
              cargo == 'Administrador' ||
              cargo == 'Coordinador Abogado' ||
              cargo == 'Coordinador Contact Center' ||
              cargo == 'Coordinador Investigador' ||
              cargo == 'Coordinador Perito' ||
              cargo == 'Coordinador Abogado CAIT'
            "
            small
            text
            icon
            outlined
            @click="asignar(item)"
            color="primary"
            title="Asignar agente"
          >
            <v-icon small>mdi-account-plus</v-icon>
          </v-btn>
          <v-btn
            v-if="
              cargo == 'Administrador' ||
              cargo == 'Coordinador Contact Center' ||
              cargo == 'Call Center' ||
              cargo == 'Coordinador Investigador' ||
              cargo == 'Investigador'
            "
            small
            icon
            text
            outlined
            @click="solicitar(item)"
            color="primary"
            title="Solicitar agente"
          >
            <v-icon small>mdi-library</v-icon>
          </v-btn>

          <!-- Gestionar / Exportar / Editar -->
          <v-btn
            v-if="
              cargo == 'Administrador' ||
              cargo == 'Coordinador Abogado' ||
              cargo == 'Coordinador Abogado CAIT' ||
              cargo == 'Coordinador Investigador' ||
              cargo == 'Coordinador Perito' ||
              cargo == 'Dibujante' ||
              cargo == 'Coordinador Contact Center' ||
              cargo == 'Abogado' ||
              (cargo == 'Abogado CAIT' && item.uidabogadocait) ||
              (cargo == 'Call Center' && item.uidcontactcenter) ||
              cargo == 'Investigador' ||
              (cargo == 'Perito' && item.uidperito)
            "
            small
            icon
            text
            outlined
            @click="gestionar(item)"
            title="Gestionar"
          >
            <v-icon small>mdi-wrench</v-icon>
          </v-btn>
          <v-btn
            v-if="
              cargo == 'Administrador' ||
              cargo == 'Call Center' ||
              cargo == 'Coordinador Contact Center'
            "
            @click="exportar(item)"
            color="primary"
            title="Exportar archivos del caso"
            small
            icon
            text
            outlined
          >
            <v-icon small>mdi-briefcase-upload-outline</v-icon>
          </v-btn>
          <v-btn
            v-if="
              (cargo == 'Administrador' ||
                cargo == 'Call Center' ||
                cargo == 'Coordinador Contact Center') &&
              item.origen_desde !== 'Salesforce'
            "
            @click="addUpdate(item)"
            color="primary"
            title="Editar Caso"
            small
            icon
            text
            outlined
          >
            <v-icon small>mdi-pencil</v-icon>
          </v-btn>
        </div>
      </template>
    </v-data-table>
    <!-- <modal-add
      v-if="showModal"
      :showModal.sync="showModal"
      :id="id"
      @actualizar="getInfo"
    ></modal-add> -->
    <modal-afectado
      v-if="showModalAfectado"
      :showModal.sync="showModalAfectado"
      :id="id"
    >
    </modal-afectado>
    <modal-add-kronos
      v-if="showModal"
      :showModal.sync="showModal"
      :id="id"
      @actualizar="getInfo"
    ></modal-add-kronos>
    <modal-asignar
      v-if="showModalAsignar"
      :showModal.sync="showModalAsignar"
      :id="id"
      :idCiudad="idCiudad"
      @actualizar="getInfo"
    ></modal-asignar>
    <!-- :areaCaso="areaCaso"    esta propiedad pertenece a modal-asignar, pero es nesario removerla para que no se muestre en el listado de casos -->
    <modal-solicitar
      v-if="showModalSolicitar"
      :showModal.sync="showModalSolicitar"
      :id="id"
      :tipoPlanCaso="tipoPlanCaso"
      @actualizar="getInfo"
    ></modal-solicitar>
    <sheet-sales-force
      v-if="showModalMovilidad"
      :showModal.sync="showModalMovilidad"
      :id="idCasoMovilidad"
    ></sheet-sales-force>
    <v-dialog v-model="showModalTimeline" max-width="980px">
      <v-card>
        <v-card-title class="d-flex align-center justify-space-between">
          <span>Timeline del caso #{{ casoTimelineSeleccionado || "--" }}</span>
          <v-btn icon text @click="showModalTimeline = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text>
          <Timeline
            v-if="showModalTimeline && casoTimelineSeleccionado"
            :caso="casoTimelineSeleccionado"
          />
        </v-card-text>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
/* eslint-disable */
import { mapState, mapActions } from "vuex";
import { db } from "../../firebase";
import Filtros from "../General/Filtros.vue";
// import ModalAdd from "./ModalAdd.vue";
import ModalAddKronos from "./ModalAddKronos.vue";
import ModalAsignar from "./ModalAsignar.vue";
import ModalSolicitar from "./ModalSolicitar.vue";
import ModalAfectado from "./ModalUsuarioAfectado.vue";
import SheetSalesForce from "./SheetSalesForce.vue";
import Timeline from "./CasoTimeline.vue";
// import ModalAddFotosDrone from "./ModalAddFotosDrone.vue";
// import moment from "moment";
import moment from "moment-timezone";
import NotificacionesAPI from "../../helpers/NotificacionesAPI";

// Relaciones que se resuelven contra otras colecciones para armar una fila.
// Solo se consultan las que tienen columna visible en `headers`.
const RELACIONES = [
  { campo: "cliente", tabla: "clientes", uid: "uidcliente" },
  { campo: "abogado", tabla: "usuarios", uid: "uidabogado" },
  { campo: "investigador", tabla: "usuarios", uid: "uidinvestigador" },
  { campo: "dibujante", tabla: "usuarios", uid: "uiddibujante" },
  { campo: "callcenter", tabla: "usuarios", uid: "uidcontactcenter" },
  { campo: "perito", tabla: "usuarios", uid: "uidperito" },
  { campo: "vehiculo", tabla: "vehiculos", uid: "uidvehiculo" },
];

export default {
  components: {
    ModalAddKronos,
    ModalAsignar,
    Filtros,
    ModalSolicitar,
    ModalAfectado,
    SheetSalesForce,
    Timeline,
    // ModalAddFotosDrone,
  },
  // eslint-disable-next-line vue/multi-word-component-names
  name: "Casos",
  data() {
    return {
      coleccion: "casos",
      consulta: "",
      condicion: "",
      campo: "",
      totalItems: 0,
      lastVisible: "",
      itemsPerPage: 0,
      ordenar: "",
      typoOrdenar: false,
      page: 0,
      options: {},
      camposfiltros: [],
      campoFiltro: "",
      operadorFiltro: "",
      valorFiltro: "",
      criterios: [],
      search: "",
      loading: true,
      desserts: [],
      showModal: false,
      id: "",
      //areaCaso: "",
      showModalMovilidad: false,
      idCasoMovilidad: "",
      showModalTimeline: false,
      casoTimelineSeleccionado: null,
      headers: [
        { text: "Caso", value: "caso" },
        { text: "Fecha Creación", value: "fecha_creacion" },
        { text: "Hora Creación", value: "hora_creacion" },
        { text: "Hora Asignación", value: "hora_asignacion" },
        { text: "Placa", value: "placa" },
        { text: "Vehiculo inmovilizado", value: "vehiculo_inmovilizado" },
        { text: "Cliente", value: "cliente" },
        { text: "Telefono", value: "telefono_usuario_1" },
        { text: "Poliza", value: "poliza" },
        { text: "Ciudad Siniestro", value: "ciudad_siniestro" },
        { text: "Origen", value: "origen_desde" },
        { text: "Tipo de caso", value: "tipocaso" },
        { text: "Tipo de plan", value: "tipo_plan" },
        { text: "Abogado", value: "abogado" },
        { text: "Investigador", value: "investigador" },
        { text: "Estado", value: "estado" },
        { text: "Tiempos", value: "tiempos", width: "300px" },
        { text: "Archivar", value: "archivar" },
        { text: "Acciones", value: "action" },
      ],
      showModalAsignar: false,
      showModalSolicitar: false,
      showModalAfectado: false,
      showModalFotosDrone: false,
      listaUsuarios: [],
      listaClientes: [],
      listaVehiculos: [],
      tomarCaso: [],
      idCiudad: "",
      estadoUsuarioLogueado: "",
      tipoPlanCaso: "",
      numero_caso: "",
      uidcontactcenter: "",
      datosCaso: {},
      agentes: [
        "uidabogado",
        "uidinvestigador",
        "uidabogadocait",
        "uidcontactcenter",
        "uidperito",
      ],
      campoAgente: "",
      consultaAgente: "",
      cargoAgente: "",
      estadoAgente: "",
      ultimoDocumento: null,
      primerDocumento: null,
      unsubscribe: null,
      camposNumericos: ["caso"],
      querySnapshot: [],
      paginas: [],
      activeQueryId: 0,
      // `*Cache` guarda el valor ya resuelto (permite leerlo sin await al pintar
      // la tabla) y `*EnVuelo` la promesa en curso, para no duplicar lecturas.
      registroCache: new Map(),
      registroEnVuelo: new Map(),
      horaAsignacionCache: new Map(),
      horaAsignacionEnVuelo: new Map(),
    };
  },
  computed: {
    ...mapState(["drawer", "logueado"]),
    columnasVisibles() {
      return new Set(this.headers.map((h) => h.value));
    },
    DRAWER_STATE: {
      get() {
        return this.drawer;
      },
    },
    cargo: {
      get() {
        return `${this.logueado.cargo}`;
      },
    },
    user() {
      return this.$store.getters.user;
    },
    autorizaCrear() {
      return this.logueado.cargo === "Call Center" ||
        this.logueado.cargo === "Coordinador Contact Center" ||
        this.logueado.cargo === "Administrador"
        ? true
        : false;
    },
  },
  async mounted() {
    this.headers.forEach((element) => {
      if (element.value === "caso" || element.value === "placa") {
        this.camposfiltros.push({
          campo: element.value,
          etiqueta: element.text,
        });
      }
    });
    await this.getInfo();
  },
  beforeDestroy() {
    if (this.unsubscribe) {
      this.unsubscribe();
    }
  },
  watch: {
    options: {
      async handler() {
        await this.filtros();
      },
      deep: true,
    },
    async tomarCaso(nuevo, old) {
      const parametro = {};
      if (nuevo.length > old.length) {
        console.log("agregar");
        if (this.cargo == "Investigador")
          parametro.uidinvestigador = this.logueado.id;
        if (this.cargo == "Abogado") parametro.uidabogado = this.logueado.id;
        if (this.cargo == "Dibujante")
          parametro.uiddibujante = this.logueado.id;
        // Guardar quién hizo la auto-asignación del caso
        parametro.uidasignador = this.logueado.id;
        // Registrar fecha y hora de la auto-asignación
        parametro.horadeasignacion = new Date();
        this.id = nuevo[nuevo.length - 1];
        await this.notificarSocket("Asignación de caso");
        await db.collection("casos").doc(this.id).update(parametro);
        this.trazabilidad("Tomo el ");
        this.enviarNotificacion(
          `${this.cargo}`,
          `${this.logueado.nombres} ${this.logueado.apellidos}`
        );
      } else if (nuevo.length < old.length) {
        console.log("quitar");
        if (this.cargo == "Investigador") parametro.uidinvestigador = "";
        if (this.cargo == "Abogado") parametro.uidabogado = "";
        if (this.cargo == "Dibujante") parametro.uiddibujante = "solicitado";
        old.forEach((el) => {
          if (nuevo.includes(el)) return;
          this.id = el;
        });

        await this.notificarSocket("Desvinculación del caso");
        await db.collection("casos").doc(this.id).update(parametro);
        this.trazabilidad("Se desvinculo del ");
      }
    },
  },
  created() {
    if (
      this.logueado.cargo == "Administrador" ||
      this.logueado.cargo == "Coordinador Contact Center" ||
      this.logueado.cargo == "Coordinador Investigador" ||
      this.logueado.cargo == "Coordinador Abogado" ||
      this.logueado.cargo == "Coordinador Abogado CAIT"
    ) {
      this.consulta = 0;
      this.campo = "caso";
      this.condicion = ">";
    }
    if (this.logueado.cargo == "Call Center") {
      this.consulta = this.logueado.id;
      this.campo = "uidcontactcenter";
      this.condicion = "==";
    }
    if (this.logueado.cargo == "Investigador") {
      this.consulta = [this.logueado.id];
      this.campo = "uidinvestigador";
      this.condicion = "in";
    }
    if (this.logueado.cargo == "Abogado") {
      this.consulta = [this.logueado.id, ""];
      this.campo = "uidabogado";
      this.condicion = "in";
    }
    if (this.logueado.cargo == "Dibujante") {
      this.consulta = [this.logueado.id, "solicitado"];
      this.campo = "uiddibujante";
      this.condicion = "in";
    }
    if (this.logueado.cargo == "Abogado CAIT") {
      this.consulta = [this.logueado.id, ""];
      this.campo = "uidabogadocait";
      this.condicion = "in";
    }
    if (this.logueado.cargo == "Coordinador Perito") {
      this.consulta = true;
      this.campo = "solicitud_perito";
      this.condicion = "==";
    }
    if (this.logueado.cargo == "Perito") {
      this.consulta = this.logueado.id;
      this.campo = "uidperito";
      this.condicion = "==";
    }
  },
  methods: {
    ...mapActions("notification", ["EnviarNotificaciones"]),
    ...mapActions("trazabilidad", ["trazabilidadEstadoUsuarios"]),
    resetRealtimeQuery() {
      if (this.unsubscribe) {
        try {
          this.unsubscribe();
        } catch (e) {
          // noop: asegurar que no reviente si ya está cerrada
        }
      }
      this.unsubscribe = null;
      this.querySnapshot = [];
      this.activeQueryId += 1;
      return this.activeQueryId;
    },
    getCacheKey(tabla, id) {
      return `${tabla}:${id}`;
    },
    verMovilidadMundial(item = {}) {
      const id = item?.id || "";
      if (!id) return;
      this.idCasoMovilidad = id;
      // Forzar re-render del sheet para garantizar que se abra siempre
      this.showModalMovilidad = false;
      this.$nextTick(() => {
        this.showModalMovilidad = true;
      });
    },
    mostrarModalFotosDrone(item = {}) {
      this.id = item?.id;
      // this.showModalFotosDrone = true;
    },
    verTimeline(item = {}) {
      this.casoTimelineSeleccionado = item?.caso ?? null;
      this.showModalTimeline = true;
    },
    async filtros() {
      const { sortBy, sortDesc } = this.options;
      this.ordenar = sortBy[0] || this.headers[0].value;
      this.typoOrdenar = sortDesc[0] ? "asc" : "desc";

      const criteriosGenericos = await this.$refs.criterios.enviarCriterios();
      
      // Si enviarCriterios devuelve false o no hay criterios válidos
      if (!criteriosGenericos || !Array.isArray(criteriosGenericos) || criteriosGenericos.length === 0) {
        this.criterios = [];
        this.campoFiltro = "";
        this.operadorFiltro = "";
        this.valorFiltro = "";
        return;
      }
      
      this.criterios = criteriosGenericos;

      if (this.criterios.length > 0 && this.criterios[0]?.valor) {
        this.criterios.forEach((element) => {
          if (element.campo && element?.valor) {
            this.campoFiltro = element.campo;
            this.operadorFiltro = element.operador;
            this.valorFiltro = element?.valor;
          }
        });
      } else {
        // Si no hay criterios válidos, limpiar los filtros
        this.campoFiltro = "";
        this.operadorFiltro = "";
        this.valorFiltro = "";
      }
    },
    async getInfo() {
      try {
        this.loading = true;
        const queryId = this.resetRealtimeQuery();
        await this.filtros();
        let consulta = db
          .collection("casos")
          .where("archivado", "==", false)
          .where(this.campo, this.condicion, this.consulta);
        // Si el usuario no es administrador, filtrar por área
        /*        if (this.logueado.cargo !== "Administrador") {
          consulta = consulta.where("area", "==", this.logueado.area || "Sin Definir");
        }*/
        const esBusquedaPlacaExacta =
          this.criterios.length > 0 &&
          this.criterios[0]?.valor &&
          this.campoFiltro === "placa" &&
          this.operadorFiltro === "==";

        if (this.criterios.length > 0 && this.criterios[0]?.valor) {
          let valorFiltroFinal;
          if (this.camposNumericos.includes(this.campoFiltro)) {
            valorFiltroFinal = parseInt(this.valorFiltro || 0);
          } else {
            valorFiltroFinal = this.valorFiltro?.toUpperCase().trim();
          }

          // Búsqueda por placa exacta: simplificada y rápida (sin realtime, sin orderBy).
          // También incluye archivados, porque el usuario suele buscar por placa sin importar el estado.
          if (esBusquedaPlacaExacta) {
            const placa = valorFiltroFinal;

            const base = db
              .collection("casos")
              .where(this.campo, this.condicion, this.consulta)
              .where("placa", "==", placa);

            const [snapActivos, snapArchivados] = await Promise.all([
              base.where("archivado", "==", false).limit(25).get(),
              base.where("archivado", "==", true).limit(25).get(),
            ]);

            if (queryId !== this.activeQueryId) return;

            const docsMap = new Map();
            snapActivos.docs.forEach((d) => docsMap.set(d.id, d));
            snapArchivados.docs.forEach((d) => docsMap.set(d.id, d));
            const docs = Array.from(docsMap.values());

            // Reset paginación (modo placa exacta)
            this.paginas = [];
            this.ultimoDocumento = null;
            this.primerDocumento = null;
            this.querySnapshot = { docs };

            await this.procesarQuerySnapshot(queryId);
            return;
          }

          consulta = consulta.where(
            this.campoFiltro,
            this.operadorFiltro,
            valorFiltroFinal
          );
          console.log(
            "getInfo() - Aplicando filtro:",
            {
              campoFiltro: this.campoFiltro,
              operadorFiltro: this.operadorFiltro,
              valorFiltro: this.valorFiltro,
              valorFiltroFinal: valorFiltroFinal,
              criterios: this.criterios,
            }
          );
        } else {
          console.log("getInfo() - No hay filtros aplicados", {
            criterios: this.criterios,
            campoFiltro: this.campoFiltro,
          });
        }

        // Siempre aplicar orderBy para que la paginación funcione correctamente
        consulta = consulta.orderBy("caso", "desc");

        consulta = consulta.limit(10);

        this.unsubscribe = consulta.onSnapshot(async (querySnapshot) => {
          if (queryId !== this.activeQueryId) return;
          this.querySnapshot = querySnapshot;
          await this.procesarQuerySnapshot(queryId);
        });
      } catch (error) {
        this.handleError(error);
      }
    },
    async getDataSiguiente() {
      if (!this.ultimoDocumento) return;
      try {
        // En modo placa exacta no paginamos
        if (this.campoFiltro === "placa" && this.operadorFiltro === "==") return;
        await this.filtros();
        this.loading = true;
        const queryId = this.resetRealtimeQuery();
        let consulta = db
          .collection(this.coleccion)
          .where("archivado", "==", false)
          .where(this.campo, this.condicion, this.consulta);
        // Si el usuario no es administrador, filtrar por área
        //        if (this.logueado.cargo !== "Administrador") {
        //          consulta = consulta.where("area", "==", this.logueado.area || "Sin Definir");
        //        }

        if (this.criterios.length > 0 && this.criterios[0]?.valor) {
          let valorFiltroFinal;
          if (this.camposNumericos.includes(this.campoFiltro)) {
            valorFiltroFinal = parseInt(this.valorFiltro || 0);
          } else {
            valorFiltroFinal = this.valorFiltro?.toUpperCase().trim();
          }
          consulta = consulta.where(
            this.campoFiltro,
            this.operadorFiltro,
            valorFiltroFinal
          );
          console.log("getDataSiguiente() - Aplicando filtro:", {
            campoFiltro: this.campoFiltro,
            operadorFiltro: this.operadorFiltro,
            valorFiltroFinal: valorFiltroFinal,
          });
        }
        // Siempre aplicar orderBy para que la paginación funcione correctamente
        consulta = consulta.orderBy("caso", "desc");

        consulta = consulta.limit(10).startAfter(this.ultimoDocumento);

        this.unsubscribe = consulta.onSnapshot(async (querySnapshot) => {
          if (queryId !== this.activeQueryId) return;
          if (!querySnapshot.empty) {
            this.querySnapshot = querySnapshot;
            this.paginas.push(this.primerDocumento);
            await this.procesarQuerySnapshot(queryId);
          }
        });
      } catch (error) {
        console.error("Error al obtener datos siguientes:", error);
        this.handleError(error);
      }
    },
    async getDataAnterior() {
      if (this.paginas.length === 0) return;
      try {
        // En modo placa exacta no paginamos
        if (this.campoFiltro === "placa" && this.operadorFiltro === "==") return;
        await this.filtros();
        this.loading = true;
        const queryId = this.resetRealtimeQuery();
        let consulta = db
          .collection(this.coleccion)
          .where("archivado", "==", false)
          .where(this.campo, this.condicion, this.consulta);
        // Si el usuario no es administrador, filtrar por área
        /*        if (this.logueado.cargo !== "Administrador") {
          consulta = consulta.where("area", "==", this.logueado.area || "Sin Definir");
        }*/

        if (this.criterios.length > 0 && this.criterios[0]?.valor) {
          let valorFiltroFinal;
          if (this.camposNumericos.includes(this.campoFiltro)) {
            valorFiltroFinal = parseInt(this.valorFiltro || 0);
          } else {
            valorFiltroFinal = this.valorFiltro?.toUpperCase().trim();
          }
          consulta = consulta.where(
            this.campoFiltro,
            this.operadorFiltro,
            valorFiltroFinal
          );
          console.log("getDataAnterior() - Aplicando filtro:", {
            campoFiltro: this.campoFiltro,
            operadorFiltro: this.operadorFiltro,
            valorFiltroFinal: valorFiltroFinal,
          });
        }
        // Siempre aplicar orderBy para que la paginación funcione correctamente
        consulta = consulta.orderBy("caso", "desc");

        const documentoAnterior = this.paginas.pop();
        consulta = consulta.limit(10).startAt(documentoAnterior);

        this.unsubscribe = consulta.onSnapshot(async (querySnapshot) => {
          if (queryId !== this.activeQueryId) return;
          if (!querySnapshot.empty) {
            this.querySnapshot = querySnapshot;
            await this.procesarQuerySnapshot(queryId);
          }
        });
      } catch (error) {
        console.error("Error al obtener datos anteriores:", error);
        this.handleError(error);
      }
    },
    formatClienteCaso(docData = {}, cliente = null) {
      const esSalesforce =
        docData?.origen_desde === "Salesforce" || docData?.origen === "Salesforce";
      if (esSalesforce) {
        const nombre = (docData?.nombre_usuario || "").trim();
        const cedula = docData?.numero_documento_usuario ?? "";
        const parts = [nombre, cedula].filter((x) => `${x}`.trim() !== "");
        return parts.join(" ");
      }
      if (cliente && Object.keys(cliente).length > 0) {
        return `${cliente.nombres || ""} ${cliente.apellidos || ""} ${
          cliente.identificacion || ""
        }`.trim();
      }
      // Fallback: si no hay registro cliente, pero el caso trae datos “planos”
      const nombre = (docData?.nombre_usuario || "").trim();
      const cedula = docData?.numero_documento_usuario ?? "";
      const parts = [nombre, cedula].filter((x) => `${x}`.trim() !== "");
      return parts.join(" ");
    },
    formatHoraAsignacionCaso(docData = {}) {
      const raw = docData?.horadeasignacion;
      if (!raw) return null;
      // Firestore Timestamp
      if (typeof raw?.toDate === "function") {
        return moment(raw.toDate()).format("HH:mm:ss");
      }
      // JS Date
      if (raw instanceof Date) {
        return moment(raw).format("HH:mm:ss");
      }
      // String "YYYY-MM-DD HH:mm:ss"
      if (typeof raw === "string") {
        const parts = raw.split(" ");
        return parts[1] || null;
      }
      // Number ms
      if (typeof raw === "number") {
        return moment(raw).format("HH:mm:ss");
      }
      return null;
    },
    formatVehiculoInmovilizado(docData = {}) {
      return docData?.vehiculo_inmovilizado === true;
    },
    polizaCaso(item = {}) {
      const esOrigen = (origen) =>
        item.origen_desde === origen || item.origen === origen;
      if (esOrigen("Mundial App")) return item.poliza_mundial || "-";
      if (esOrigen("Salesforce")) return item.tipo_poliza || "-";
      return "-";
    },
    async procesarQuerySnapshot() {
      const datos = await Promise.all(
        this.querySnapshot.docs.map(async (doc) => {
          const cliente =
            doc.data().uidcliente &&
            (await this.BuscarRegistro(doc.data().uidcliente, "clientes"));

          const abogado =
            doc.data().uidabogado &&
            (await this.BuscarRegistro(doc.data().uidabogado, "usuarios"));
          doc.data().uidabogado &&
            this.logueado.cargo == "Abogado" &&
            this.tomarCaso.push(doc.id);
          const dibujante =
            doc.data().uiddibujante != "solicitado" &&
            doc.data().uiddibujante &&
            (await this.BuscarRegistro(doc.data().uiddibujante, "usuarios"));
          doc.data().uiddibujante != "solicitado" &&
            doc.data().uiddibujante &&
            this.logueado.cargo == "Dibujante" &&
            this.tomarCaso.push(doc.id);
          const callcenter =
            doc.data().uidcontactcenter &&
            (await this.BuscarRegistro(
              doc.data().uidcontactcenter,
              "usuarios"
            ));
          const investigador =
            doc.data().uidinvestigador &&
            (await this.BuscarRegistro(doc.data().uidinvestigador, "usuarios"));
          doc.data().uidinvestigador &&
            this.logueado.cargo == "Investigador" &&
            this.tomarCaso.push(doc.id);
          const perito =
            doc.data().uidperito &&
            (await this.BuscarRegistro(doc.data().uidperito, "usuarios"));
          const vehiculo =
            doc.data().uidvehiculo &&
            (await this.BuscarRegistro(doc.data().uidvehiculo, "vehiculos"));

          // Obtener hora de asignación
          const horaAsignacion =
            this.formatHoraAsignacionCaso(doc.data()) ||
            (await this.obtenerHoraAsignacion(doc.data().caso));

          return {
            id: doc.id,
            ...doc.data(),
            cliente: this.formatClienteCaso(doc.data(), cliente),
            vehiculo_inmovilizado: this.formatVehiculoInmovilizado(doc.data()),
            abogado: abogado
              ? `${abogado.nombres} ${abogado.apellidos} ${abogado.identificacion}`
              : "",
            dibujante: dibujante
              ? `${dibujante.nombres} ${dibujante.apellidos} ${dibujante.identificacion}`
              : "",
            callcenter: callcenter
              ? `${callcenter.nombres} ${callcenter.apellidos} ${callcenter.identificacion}`
              : "",
            investigador: investigador
              ? `${investigador.nombres} ${investigador.apellidos} ${investigador.identificacion}`
              : "",
            perito: perito
              ? `${perito.nombres} ${perito.apellidos} ${perito.identificacion}`
              : "",
            vehiculo: vehiculo
              ? `Placa: ${vehiculo.placa} Marca: ${vehiculo.marca}`
              : "",
            fecha_creacion: moment(doc.data().creado).format("YYYY-MM-DD"),
            hora_creacion: moment(doc.data().creado).format("HH:mm:ss"),
            hora_asignacion: horaAsignacion || "--:--:--",
            creado: moment(doc.data().creado).format("YYYY-MM-DD HH:mm:ss"),
          };
        })
      );

      this.desserts = datos;
      this.ultimoDocumento =
        this.querySnapshot.docs[this.querySnapshot.docs.length - 1];
      this.primerDocumento = this.querySnapshot.docs[0];
      this.loading = false;
    },
    async getData() {
      //TODO: CORREGIR Parmejorar la velocidad de la consulta
      db.collection(this.coleccion)
        .where(this.campo, this.condicion, this.consulta)
        .where("archivado", "==", false)
        .get()
        .then((res) => {
          this.totalItems = res.size;
        });
      const { itemsPerPage, page, sortBy, sortDesc } = this.options;
      this.itemsPerPage = itemsPerPage;
      this.ordenar = sortBy[0] || this.headers[0].value;
      this.typoOrdenar = sortDesc[0] ? "asc" : "desc";
      this.criterios = await this.$refs.criterios.enviarCriterios();
      if (this.criterios.length > 0 && this.criterios[0].valor) {
        this.criterios.forEach((element) => {
          if (element.campo && element.valor) {
            this.campoFiltro = element.campo;
            this.operadorFiltro = element.operador;
            // eslint-disable-next-line
            this.valorFiltro = element.campo != "caso" ? element.valor.toUpperCase().trim() : parseInt(element.valor, 10);
          }
        });
      }
      try {
        if (this.criterios.length > 0 && this.criterios[0].valor) {
          this.buscarCuando();
        } else if (page == 1) {
          console.log("inicio");
          this.inicio();
        } else if (this.page < page) {
          console.log("siguiente");
          this.siguiente();
        } else {
          console.log("anterior");
          this.anterior();
        }
        this.page = page;
        this.loading = false;
      } catch (err) {
        this.handleError(err);
      }
    },
    async trazabilidad(nota) {
      try {
        // se consulta para saber el estado del asesor logueado
        db.collection("casos")
          .where(this.campo, "==", this.logueado.id)
          .where("archivado", "==", false)
          .where("estado", "not-in", [
            "Cancelado",
            "Conciliado",
            "No conciliado",
            "CERRADO",
          ])
          .get()
          .then((res) => {
            this.estadoUsuarioLogueado =
              res.size > 1 ? "Activo multiple" : "Activo ocupado";
            // se actualiza el estado del usuario logueado
            db.collection("usuarios")
              .doc(this.logueado.id)
              .update({ disponibilidad: this.estadoUsuarioLogueado })
              .then(() => {
                this.$store.dispatch("updatePerfilLogueado", {
                  id: this.logueado.id,
                });
              });
            // se guarda la trazabilidad del caso
            this.$store.dispatch("trazabilidadCaso", {
              descripcion: `El ${this.cargo} ${nota} caso`,
              uidcaso: this.id,
              uidcreador: this.logueado.id,
            });
            this.$store.dispatch("trazabilidadEstadoUsuarios", {
              descripcion: `El ${this.cargo} ${nota} caso`,
              estado: this.estadoUsuarioLogueado,
              uidcaso: this.id,
              cargo: this.logueado.cargo,
              uidcreador: this.logueado.id,
              uidusuario: this.logueado.id,
            });
          });
      } catch (error) {
        this.handleError(error);
      }
    },
    async BuscarRegistro(id, tabla) {
      if (!id || !tabla) return {};
      const key = this.getCacheKey(tabla, id);
      if (this.registroCache.has(key)) return this.registroCache.get(key);
      if (this.registroEnVuelo.has(key)) return this.registroEnVuelo.get(key);

      const prom = db
        .collection(tabla)
        .doc(id)
        .get()
        .then((snap) => (snap.exists ? snap.data() || {} : {}))
        .catch((error) => {
          console.error(`Error consultando ${tabla}/${id}:`, error);
          return {};
        })
        .then((datos) => {
          this.registroCache.set(key, datos);
          this.registroEnVuelo.delete(key);
          return datos;
        });

      this.registroEnVuelo.set(key, prom);
      return prom;
    },
    async notificarSocket(momento) {
      moment.tz.setDefault("America/Bogota");
      const caso = await this.BuscarRegistro(this.id, "casos");
      const identification =
        this.logueado.identificacion ||
        JSON.parse(localStorage.getItem("logueado")).identificacion;
      const fechaActual = moment().format("YYYY-MM-DD HH:mm:ss");
      if (this.cargo == "Investigador") {
        await db.collection("notificaciones").add({
          cedula: identification,
          caso: caso.caso,
          momento,
          fechahora: fechaActual,
        });
      }
    },
    asignar(item) {
      this.idCiudad = item.uidciudad;
      this.id = item.id;
      //this.areaCaso = item?.area || "Sin Definir";
      this.showModalAsignar = true;
    },
    solicitar(item) {
      this.tipoPlanCaso = item.tipo_plan;
      this.id = item.id;
      this.showModalSolicitar = true;
    },
    async gestionar(e) {
      localStorage.setItem("id", e.id);
      this.$router.push(`/gestionar-caso/${e.id}/chat`);
    },
    async buscarCuando() {
      db.collection(this.coleccion)
        .where(this.campoFiltro, this.operadorFiltro, this.valorFiltro)
        .where(this.campo, this.condicion, this.consulta)
        .where("archivado", "==", false)
        .limit(this.itemsPerPage)
        .get()
        .then(async (resul) => {
          this.lastVisible = resul.docs[resul.docs.length - 1] || null;
          this.firstVisible = resul.docs[0] || null;
          // eslint-disable-next-line no-unused-vars
          const res = await Promise.all(
            resul.docs.map(async (doc) => {
              const cliente =
                doc.data().uidcliente &&
                (await this.BuscarRegistro(doc.data().uidcliente, "clientes"));
              const abogado =
                doc.data().uidabogado &&
                (await this.BuscarRegistro(doc.data().uidabogado, "usuarios"));
              doc.data().uidabogado &&
                this.logueado.cargo == "Abogado" &&
                this.tomarCaso.push(doc.id);
              const dibujante =
                doc.data().uiddibujante != "solicitado" &&
                doc.data().uiddibujante &&
                (await this.BuscarRegistro(
                  doc.data().uiddibujante,
                  "usuarios"
                ));
              doc.data().uiddibujante != "solicitado" &&
                doc.data().uiddibujante &&
                this.logueado.cargo == "Dibujante" &&
                this.tomarCaso.push(doc.id);
              const callcenter =
                doc.data().uidcontactcenter &&
                (await this.BuscarRegistro(
                  doc.data().uidcontactcenter,
                  "usuarios"
                ));
              const investigador =
                doc.data().uidinvestigador &&
                (await this.BuscarRegistro(
                  doc.data().uidinvestigador,
                  "usuarios"
                ));
              doc.data().uidinvestigador &&
                this.logueado.cargo == "Investigador" &&
                this.tomarCaso.push(doc.id);
              const perito =
                doc.data().uidperito &&
                (await this.BuscarRegistro(doc.data().uidperito, "usuarios"));
              const vehiculo =
                doc.data().uidvehiculo &&
                (await this.BuscarRegistro(
                  doc.data().uidvehiculo,
                  "vehiculos"
                ));

              const horaAsignacion =
                this.formatHoraAsignacionCaso(doc.data()) ||
                (await this.obtenerHoraAsignacion(doc.data().caso));

              return {
                id: doc.id,
                ...doc.data(),
                cliente: this.formatClienteCaso(doc.data(), cliente),
                vehiculo_inmovilizado: this.formatVehiculoInmovilizado(
                  doc.data()
                ),
                abogado: abogado
                  ? `${abogado.nombres} ${abogado.apellidos} ${abogado.identificacion}`
                  : "",
                dibujante: dibujante
                  ? `${dibujante.nombres} ${dibujante.apellidos} ${dibujante.identificacion}`
                  : "",
                callcenter: callcenter
                  ? `${callcenter.nombres} ${callcenter.apellidos} ${callcenter.identificacion}`
                  : "",
                investigador: investigador
                  ? `${investigador.nombres} ${investigador.apellidos} ${investigador.identificacion}`
                  : "",
                perito: perito
                  ? `${perito.nombres} ${perito.apellidos} ${perito.identificacion}`
                  : "",
                vehiculo: vehiculo
                  ? `Placa: ${vehiculo.placa} Marca: ${vehiculo.marca}`
                  : "",
                fecha_creacion: moment(doc.data().creado).format("YYYY-MM-DD"),
                hora_creacion: moment(doc.data().creado).format("HH:mm:ss"),
                hora_asignacion: horaAsignacion || "--:--:--",
                creado: moment(doc.data().creado).format("YYYY-MM-DD HH:mm:ss"),
              };
            })
          );
          // this.desserts = res;
          console.log(this.desserts);
        });
    },
    async inicio() {
      try {
        this.loading = true;
        db.collection(this.coleccion)
          .where(this.campo, this.condicion, this.consulta)
          .where("archivado", "==", false)
          .limit(this.itemsPerPage)
          .orderBy(this.ordenar, this.typoOrdenar)
          .onSnapshot(async (resul) => {
            this.lastVisible = resul.docs[resul.docs.length - 1] || null;
            this.firstVisible = resul.docs[0] || null;

            const res = await Promise.all(
              resul.docs.map(async (doc) => {
                const cliente =
                  doc.data().uidcliente &&
                  (await this.BuscarRegistro(
                    doc.data().uidcliente,
                    "clientes"
                  ));
                const abogado =
                  doc.data().uidabogado &&
                  (await this.BuscarRegistro(
                    doc.data().uidabogado,
                    "usuarios"
                  ));
                doc.data().uidabogado &&
                  this.logueado.cargo == "Abogado" &&
                  this.tomarCaso.push(doc.id);
                const dibujante =
                  doc.data().uiddibujante != "solicitado" &&
                  doc.data().uiddibujante &&
                  (await this.BuscarRegistro(
                    doc.data().uiddibujante,
                    "usuarios"
                  ));
                doc.data().uiddibujante != "solicitado" &&
                  doc.data().uiddibujante &&
                  this.logueado.cargo == "Dibujante" &&
                  this.tomarCaso.push(doc.id);
                const callcenter =
                  doc.data().uidcontactcenter &&
                  (await this.BuscarRegistro(
                    doc.data().uidcontactcenter,
                    "usuarios"
                  ));
                const investigador =
                  doc.data().uidinvestigador &&
                  (await this.BuscarRegistro(
                    doc.data().uidinvestigador,
                    "usuarios"
                  ));
                doc.data().uidinvestigador &&
                  this.logueado.cargo == "Investigador" &&
                  this.tomarCaso.push(doc.id);
                const perito =
                  doc.data().uidperito &&
                  (await this.BuscarRegistro(doc.data().uidperito, "usuarios"));
                const vehiculo =
                  doc.data().uidvehiculo &&
                  (await this.BuscarRegistro(
                    doc.data().uidvehiculo,
                    "vehiculos"
                  ));

                const horaAsignacion =
                  this.formatHoraAsignacionCaso(doc.data()) ||
                  (await this.obtenerHoraAsignacion(doc.data().caso));

                return {
                  id: doc.id,
                  ...doc.data(),
                  cliente: this.formatClienteCaso(doc.data(), cliente),
                  vehiculo_inmovilizado: this.formatVehiculoInmovilizado(
                    doc.data()
                  ),
                  abogado: abogado
                    ? `${abogado.nombres} ${abogado.apellidos} ${abogado.identificacion}`
                    : "",
                  dibujante: dibujante
                    ? `${dibujante.nombres} ${dibujante.apellidos} ${dibujante.identificacion}`
                    : "",
                  callcenter: callcenter
                    ? `${callcenter.nombres} ${callcenter.apellidos} ${callcenter.identificacion}`
                    : "",
                  investigador: investigador
                    ? `${investigador.nombres} ${investigador.apellidos} ${investigador.identificacion}`
                    : "",
                  perito: perito
                    ? `${perito.nombres} ${perito.apellidos} ${perito.identificacion}`
                    : "",
                  vehiculo: vehiculo
                    ? `Placa: ${vehiculo.placa} Marca: ${vehiculo.marca}`
                    : "",
                  fecha_creacion: moment(doc.data().creado).format("YYYY-MM-DD"),
                  hora_creacion: moment(doc.data().creado).format("HH:mm:ss"),
                  hora_asignacion: horaAsignacion || "--:--:--",
                  creado: moment(doc.data().creado).format(
                    "YYYY-MM-DD HH:mm:ss"
                  ),
                };
              })
            );
            this.desserts = res;
          });
      } catch (error) {
        this.handleError(error);
      }
    },
    async siguiente() {
      try {
        this.loading = true;
        db.collection(this.coleccion)
          .where(this.campo, this.condicion, this.consulta)
          .where("archivado", "==", false)
          .limit(this.itemsPerPage)
          .orderBy(this.ordenar, this.typoOrdenar)
          .startAfter(this.lastVisible)
          .get()
          .then(async (resul) => {
            this.lastVisible = resul.docs[resul.docs.length - 1] || null;
            this.firstVisible = resul.docs[0] || null;
            // eslint-disable-next-line no-unused-vars
            const res = await Promise.all(
              resul.docs.map(async (doc) => {
                const cliente =
                  doc.data().uidcliente &&
                  (await this.BuscarRegistro(
                    doc.data().uidcliente,
                    "clientes"
                  ));
                const abogado =
                  doc.data().uidabogado &&
                  (await this.BuscarRegistro(
                    doc.data().uidabogado,
                    "usuarios"
                  ));
                doc.data().uidabogado &&
                  this.logueado.cargo == "Abogado" &&
                  this.tomarCaso.push(doc.id);
                const dibujante =
                  doc.data().uiddibujante != "solicitado" &&
                  doc.data().uiddibujante &&
                  (await this.BuscarRegistro(
                    doc.data().uiddibujante,
                    "usuarios"
                  ));
                doc.data().uiddibujante != "solicitado" &&
                  doc.data().uiddibujante &&
                  this.logueado.cargo == "Dibujante" &&
                  this.tomarCaso.push(doc.id);
                const callcenter =
                  doc.data().uidcontactcenter &&
                  (await this.BuscarRegistro(
                    doc.data().uidcontactcenter,
                    "usuarios"
                  ));
                const investigador =
                  doc.data().uidinvestigador &&
                  (await this.BuscarRegistro(
                    doc.data().uidinvestigador,
                    "usuarios"
                  ));
                doc.data().uidinvestigador &&
                  this.logueado.cargo == "Investigador" &&
                  this.tomarCaso.push(doc.id);
                const perito =
                  doc.data().uidperito &&
                  (await this.BuscarRegistro(doc.data().uidperito, "usuarios"));
                const vehiculo =
                  doc.data().uidvehiculo &&
                  (await this.BuscarRegistro(
                    doc.data().uidvehiculo,
                    "vehiculos"
                  ));

                const horaAsignacion =
                  this.formatHoraAsignacionCaso(doc.data()) ||
                  (await this.obtenerHoraAsignacion(doc.data().caso));

                return {
                  id: doc.id,
                  ...doc.data(),
                  cliente: this.formatClienteCaso(doc.data(), cliente),
                  vehiculo_inmovilizado: this.formatVehiculoInmovilizado(
                    doc.data()
                  ),
                  abogado: abogado
                    ? `${abogado.nombres} ${abogado.apellidos} ${abogado.identificacion}`
                    : "",
                  dibujante: dibujante
                    ? `${dibujante.nombres} ${dibujante.apellidos} ${dibujante.identificacion}`
                    : "",
                  callcenter: callcenter
                    ? `${callcenter.nombres} ${callcenter.apellidos} ${callcenter.identificacion}`
                    : "",
                  investigador: investigador
                    ? `${investigador.nombres} ${investigador.apellidos} ${investigador.identificacion}`
                    : "",
                  perito: perito
                    ? `${perito.nombres} ${perito.apellidos} ${perito.identificacion}`
                    : "",
                  vehiculo: vehiculo
                    ? `Placa: ${vehiculo.placa} Marca: ${vehiculo.marca}`
                    : "",
                  fecha_creacion: moment(doc.data().creado).format("YYYY-MM-DD"),
                  hora_creacion: moment(doc.data().creado).format("HH:mm:ss"),
                  hora_asignacion: horaAsignacion || "--:--:--",
                  creado: moment(doc.data().creado).format(
                    "YYYY-MM-DD HH:mm:ss"
                  ),
                };
              })
            );
            // this.desserts = res;
          });
      } catch (error) {
        this.handleError(error);
      }
    },
    async anterior() {
      try {
        this.loading = true;
        db.collection(this.coleccion)
          .where(this.campo, this.condicion, this.consulta)
          .where("archivado", "==", false)
          .limitToLast(this.itemsPerPage)
          .orderBy(this.ordenar, this.typoOrdenar)
          .endBefore(this.firstVisible)
          .get()
          .then(async (resul) => {
            this.lastVisible = resul.docs[resul.docs.length - 1] || null;
            this.firstVisible = resul.docs[0] || null;
            // eslint-disable-next-line no-unused-vars
            const res = await Promise.all(
              resul.docs.map(async (doc) => {
                const cliente =
                  doc.data().uidcliente &&
                  (await this.BuscarRegistro(
                    doc.data().uidcliente,
                    "clientes"
                  ));
                const abogado =
                  doc.data().uidabogado &&
                  (await this.BuscarRegistro(
                    doc.data().uidabogado,
                    "usuarios"
                  ));
                doc.data().uidabogado &&
                  this.logueado.cargo == "Abogado" &&
                  this.tomarCaso.push(doc.id);
                const dibujante =
                  doc.data().uiddibujante != "solicitado" &&
                  doc.data().uiddibujante &&
                  (await this.BuscarRegistro(
                    doc.data().uiddibujante,
                    "usuarios"
                  ));
                doc.data().uiddibujante != "solicitado" &&
                  doc.data().uiddibujante &&
                  this.logueado.cargo == "Dibujante" &&
                  this.tomarCaso.push(doc.id);
                const callcenter =
                  doc.data().uidcontactcenter &&
                  (await this.BuscarRegistro(
                    doc.data().uidcontactcenter,
                    "usuarios"
                  ));
                const investigador =
                  doc.data().uidinvestigador &&
                  (await this.BuscarRegistro(
                    doc.data().uidinvestigador,
                    "usuarios"
                  ));
                doc.data().uidinvestigador &&
                  this.logueado.cargo == "Investigador" &&
                  this.tomarCaso.push(doc.id);
                const perito =
                  doc.data().uidperito &&
                  (await this.BuscarRegistro(doc.data().uidperito, "usuarios"));
                const vehiculo =
                  doc.data().uidvehiculo &&
                  (await this.BuscarRegistro(
                    doc.data().uidvehiculo,
                    "vehiculos"
                  ));

                const horaAsignacion =
                  this.formatHoraAsignacionCaso(doc.data()) ||
                  (await this.obtenerHoraAsignacion(doc.data().caso));

                return {
                  id: doc.id,
                  ...doc.data(),
                  cliente: this.formatClienteCaso(doc.data(), cliente),
                  vehiculo_inmovilizado: this.formatVehiculoInmovilizado(
                    doc.data()
                  ),
                  abogado: abogado
                    ? `${abogado.nombres} ${abogado.apellidos} ${abogado.identificacion}`
                    : "",
                  dibujante: dibujante
                    ? `${dibujante.nombres} ${dibujante.apellidos} ${dibujante.identificacion}`
                    : "",
                  callcenter: callcenter
                    ? `${callcenter.nombres} ${callcenter.apellidos} ${callcenter.identificacion}`
                    : "",
                  investigador: investigador
                    ? `${investigador.nombres} ${investigador.apellidos} ${investigador.identificacion}`
                    : "",
                  perito: perito
                    ? `${perito.nombres} ${perito.apellidos} ${perito.identificacion}`
                    : "",
                  vehiculo: vehiculo
                    ? `Placa: ${vehiculo.placa} Marca: ${vehiculo.marca}`
                    : "",
                  fecha_creacion: moment(doc.data().creado).format("YYYY-MM-DD"),
                  hora_creacion: moment(doc.data().creado).format("HH:mm:ss"),
                  hora_asignacion: horaAsignacion || "--:--:--",
                  creado: moment(doc.data().creado).format(
                    "YYYY-MM-DD HH:mm:ss"
                  ),
                };
              })
            );
            // this.desserts = res;
          });
      } catch (error) {
        this.handleError(error);
      }
    },
    addUpdate(item = "") {
      if (!this.autorizaCrear) {
        this.$swal({
          icon: "info",
          title: "Oops...",
          text: "Usuario no autorizado",
        });
        return;
      }
      this.id = item.id;
      this.showModal = true;
    },
    autorizar(item) {
      this.id = item.id;
      this.numero_caso = item.caso;
      this.uidcontactcenter = item.uidcontactcenter;
      this.$swal({
        title: "",
        text: `¿Esta seguro de autorizar asistencia especial al caso # ${this.numero_caso}?`,
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        confirmButtonText: "Si, Autorizar !!",
        cancelButtonText: "No",
        cancelButtonColor: "#d33",
      }).then((result) => {
        if (result.value) {
          db.collection(this.coleccion)
            .doc(item.id)
            .update({ aprobar_atencion: true });
          // se guarda la trazabilidad del caso
          this.$store.dispatch("trazabilidadCaso", {
            descripcion: "Se autoriza la atención del caso",
            uidcaso: item.id,
            uidcreador: this.logueado.id,
          });
          //TODO: ENVIAR NOTIFICACIÓN AL ASESOR ASOCIADO AL CASO
          this.envioNotificacion();
          this.$swal("Operación Exitosa", "", "success");
          this.getInfo();
        }
      });
    },
    async envioNotificacion() {
      const usuarios = await db
        .collection("usuarios")
        .where("uidcontactcenter", "==", this.uidcontactcenter)
        .get();

      const objUsuNotificar = usuarios.docs.map((e) => ({
        ...e.data(),
      }));

      const usu = objUsuNotificar
        .filter((e) => {
          return e.tokenPush;
        })
        .map((u) => {
          return u.tokenPush;
        });

      this.registration_ids = [...usu];
      this.EnviarNotificaciones({
        registration_ids: this.registration_ids,
        title: "Autorización",
        message: `Se autoriza la atención del caso #${this.numero_caso}`,
      });
    },
    archivar(item = "") {
      this.datosCaso = item;
      this.id = item.id;
      this.$swal({
        title: "",
        text: `¿Deseas archivar el caso # ${item?.caso}?`,
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        confirmButtonText: "Si, Archivar !!",
        cancelButtonText: "Cancelar",
        cancelButtonColor: "#d33",
      }).then((result) => {
        if (result.value) {
          db.collection(this.coleccion)
            .doc(item.id)
            .update({ archivado: true });
          this.actualizarEstadoAgente();
          this.$swal("Caso Archivado", "", "success");
          this.getInfo();
        }
      });
    },
    infoCaso(item) {
      this.showModalAfectado = true;
      this.id = item.id;
    },
    async actualizarEstadoAgente() {
      // consultamos la cantidad de caso en los que esta asociado para determinar el estado
      for (const el of this.agentes) {
        if (el == "uidabogado") {
          if (!this.datosCaso.uidabogado) continue;
          this.campoAgente = "uidabogado";
          this.consultaAgente = this.datosCaso.uidabogado;
          this.cargoAgente = "Abogado";
        } else if (el == "uidabogadocait") {
          if (!this.datosCaso.uidabogadocait) continue;
          this.campoAgente = "uidabogadocait";
          this.consultaAgente = this.datosCaso.uidabogadocait;
          this.cargoAgente = "Abogado CAIT";
        } else if (el == "uidcontactcenter") {
          if (!this.datosCaso.uidcontactcenter) continue;
          this.campoAgente = "uidcontactcenter";
          this.consultaAgente = this.datosCaso.uidcontactcenter;
          this.cargoAgente = "Call Center";
        } else if (el == "uidinvestigador") {
          if (!this.datosCaso.uidinvestigador) continue;
          this.campoAgente = "uidinvestigador";
          this.consultaAgente = this.datosCaso.uidinvestigador;
          this.cargoAgente = "Investigador";
        } else if (el == "uidperito") {
          if (!this.datosCaso.uidperito) continue;
          this.campoAgente = "uidperito";
          this.consultaAgente = this.datosCaso.uidperito;
          this.cargoAgente = "Perito";
        }
        try {
          const result = await db
            .collection("casos")
            .where(this.campoAgente, "==", this.consultaAgente)
            .where("archivado", "==", false)
            .where("estado", "not-in", [
              "Cancelado",
              "Conciliado",
              "No conciliado",
            ])
            .get();
          this.estadoAgente =
            result.size > 1 ? "Activo multiple" : "Activo ocupado";
          await db
            .collection("usuarios")
            .doc(this.consultaAgente)
            .update({ disponibilidad: this.estadoAgente });
          console.log("se actualiza el estado del usuario", this.campoAgente);
          if (
            this.datosCaso.estado === "Cancelado" ||
            this.datosCaso.estado === "Conciliado" ||
            this.datosCaso.estado === "No conciliado"
          ) {
            return;
          }
          this.trazabilidadEstadoUsuarios({
            descripcion: `El ${this.cargoAgente} ha sido liberado del caso # ${this.datosCaso.caso}`,
            estado: this.estadoAgente,
            uidcaso: this.id,
            cargo: this.cargoAgente,
            uidcreador: this.logueado.id,
            uidusuario: this.consultaAgente,
          });
        } catch (error) {
          console.log(error);
          this.handleError(error);
        }
      }
    },
    async exportar(item) {
      const myHeaders = new Headers();
      myHeaders.append("Content-Type", "application/json");
      myHeaders.append("Access-Control-Allow-Origin", "*");

      const requestOptions = {
        method: "GET",
        headers: myHeaders,
        redirect: "follow",
      };

      try {
        const { isConfirmed = false } = await this.$swal({
          title: "Esta seguro de querer exportar los archivos del caso?",
          icon: "warning",
          showCancelButton: true,
          confirmButtonColor: "#3085d6",
          cancelButtonColor: "#d33",
          cancelButtonText: "Cancelar",
          confirmButtonText: "Si, Exportar",
        });
        if (isConfirmed) {
          fetch(
            `${process.env.VUE_APP_CLOUDFUNCTIONURL}/generarSftp?casoId=${item.id}&token=${this.logueado.tokenPush}`,
            requestOptions
          )
            .then((response) => response.json())
            .then((result) =>
              this.$swal({
                icon: "info",
                title: "OK",
                text: result.messages,
              })
            )
            .catch((error) => console.log("error", error));
        }
      } catch ({ messages }) {
        const { error = "error no identificado" } = messages;
        this.$swal({ icon: "error", title: "Oops...", text: error });
      }
    },
    async enviarNotificacion(tipo, usuario) {
      try {
        const objCaso = await db.collection("casos").doc(this.id).get();
        const { uidconductor, caso, uidcontactcenter } = objCaso.data();
        this.numero_caso = caso;
        if (uidconductor) {
          const objCliente = await db
            .collection("clientes")
            .doc(uidconductor)
            .get();
          const objAsesor = await db
            .collection("usuarios")
            .doc(uidcontactcenter)
            .get();
          // console.log(objCliente.data());
          // TODO: MEJORAR TAJER CALVO
          const objDatosCliente = objCliente.data();
          const objDatosAsesor = objAsesor.data();
          let tokenPush = [];
          tokenPush.push(objDatosCliente.tokenPush);
          tokenPush.push(objDatosAsesor.tokenPush);
          if (tokenPush) {
            // Enviar notificacion ORG
            await this.EnviarNotificaciones({
              registration_ids: tokenPush,
              title: "CASO ASIGNADO",
              message: `EL ${tipo.toUpperCase()} ${usuario.toUpperCase()} HA SIDO ASIGNADO AL CASO # ${
                this.numero_caso
              }`,
              url: this.url,
            });
          }
        }
      } catch (error) {
        console.log(error);
      }
    },
    async obtenerHoraAsignacion(numeroCaso) {
      try {
        if (!numeroCaso) return null;
        const cacheKey = String(numeroCaso || "");
        if (this.horaAsignacionCache.has(cacheKey)) {
          return this.horaAsignacionCache.get(cacheKey);
        }
        if (this.horaAsignacionEnVuelo.has(cacheKey)) {
          return this.horaAsignacionEnVuelo.get(cacheKey);
        }

        const prom = (async () => {
          // Buscar notificaciones recientes del caso (optimiza: evita traer todo)
          const snapshot = await db
            .collection("notificaciones")
            .where("caso", "==", numeroCaso)
            .orderBy("fechahora", "desc")
            .limit(30)
            .get();

          if (snapshot.empty) {
            return null;
          }

          // Buscar la notificación de asignación (puede tener variaciones en el texto)
          let notificacionAsignacion = null;
          let fechaMasReciente = null;

          snapshot.forEach((doc) => {
            const data = doc.data();
            const momento = data.momento;
            const fechahora = data.fechahora;

            if (momento && fechahora) {
              // Normalizar el momento para comparar (similar a CasoTimeline)
              const momentoNormalizado = momento
                .toLowerCase()
                .trim()
                .replace(/[\u200B-\u200D\uFEFF]/g, "")
                .replace(/\s+/g, " ");

              // Verificar si es una notificación de asignación
              if (
                momentoNormalizado.includes("asignación") ||
                momentoNormalizado.includes("asignacion")
              ) {
                // Si no hay una notificación guardada o esta es más reciente
                if (!fechaMasReciente || fechahora > fechaMasReciente) {
                  fechaMasReciente = fechahora;
                  notificacionAsignacion = data;
                }
              }
            }
          });

          if (notificacionAsignacion && notificacionAsignacion.fechahora) {
            // Extraer solo la hora del formato "2025-10-15 09:07:28"
            return notificacionAsignacion.fechahora.split(" ")[1] || null;
          }
          return null;
        })()
          .catch(() => null)
          .then((hora) => {
            this.horaAsignacionCache.set(cacheKey, hora);
            this.horaAsignacionEnVuelo.delete(cacheKey);
            return hora;
          });

        this.horaAsignacionEnVuelo.set(cacheKey, prom);
        return prom;
      } catch (error) {
        console.error("Error al obtener hora de asignación:", error);
        return null;
      }
    },
    handleError({ message }) {
      this.$swal({ icon: "error", title: "Oops...", text: message });
      this.loading = false;
    },
  },
};
</script>

<style src="./Caso.scss" lang="scss"></style>
